import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { getProjects, fetchProjects } from 'explore/ducks/projects';
import { fetchIndustriesIfNeeded } from 'common/ducks/industry';
import ProjectsPage from 'explore/components/projects';

ProjectsPage.need = [
  fetchProjects,
  fetchIndustriesIfNeeded,
];

function mapStateToProps(state) {
  return {
    projectsState: getProjects(state),
    projectsFetching: getProjects(state).isFetching,
    categories: state.categories.data,
    industriesFetching: state.industry.isFetching,
    industries: state.industry.data,
    user: state.user,
  };
}
function mapDispatchToProps(dispatch, { location }) {
  const actions = {
    fetchProjects: partial(fetchProjects, location.query),
    fetchIndustriesIfNeeded,
  };

  return bindActionCreators(actions, dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectsPage));



// WEBPACK FOOTER //
// ./explore/containers/projects.jsx